<div [ngClass]="{
                'lnr-sidemenu-item': isMobile,
                'lnr-sidemenu-item-desktop': !isMobile,
                'expand-row': expandRow
                }">
  <mat-icon class="icon">{{ icon }}</mat-icon>
  <span class="text">
    <ng-content></ng-content>
  </span>
</div>
